import { useState } from "react";
import { Navigate, useParams } from "react-router-dom";

import Stepper from "components/Stepper";
import { APPLY_HAULPAY_DESCRIPTION_LIST } from "constants/haulpay";
import JoinBankAccounts from "features/main/HaulPay/Join/modules/BankAccount";
import JoinCreateInfo from "features/main/HaulPay/Join/modules/CreateInfo";
import JoinDocs from "features/main/HaulPay/Join/modules/Docs";
import JoinSummary from "features/main/HaulPay/Join/modules/Summary";
import HaulPayPendingStatus from "features/main/HaulPay/Status/Pending";
import OnboardingLayout from "layouts/Onboarding";
import { IPlaidAccount } from "models/HaulPay";
import { IUserInfoForm } from "models/User";
import styles from "./style.module.scss";

interface ISectionProps {
  step: number;
  setStepCallback: (step: number) => void;
  createInfoFormData?: IUserInfoForm;
  permission?: boolean;
  submitData?: any;
  setSubmitData: (
    data: IUserInfoForm & {
      factoring_id?: string;
      bank_accounts?: IPlaidAccount[];
    }
  ) => void;
}

function SelectedSection({
  step,
  setStepCallback,
  submitData,
  setSubmitData
}: Readonly<ISectionProps>) {
  switch (step) {
    case 0:
      return (
        <JoinCreateInfo
          submitData={submitData}
          onNext={(data) => {
            setSubmitData(data);
            setStepCallback(1);
          }}
        />
      );

    case 1:
      return (
        <JoinBankAccounts
          onNext={(bank_accounts) => {
            setSubmitData({ ...submitData, bank_accounts: bank_accounts });
            setStepCallback(2);
          }}
        />
      );

    case 2:
      return (
        <JoinDocs
          submitData={submitData}
          onNext={(docs) => {
            setSubmitData({ ...submitData, docs: docs });
            setStepCallback(3);
          }}
        />
      );

    case 3:
      return <JoinSummary submitData={submitData} onNext={() => setStepCallback(4)} />;

    case 4:
      return <HaulPayPendingStatus />;

    default:
      return null;
  }
}

export default function ApplyHaulpay() {
  const [step, setStep] = useState(0);
  const [submitData, setSubmitData] = useState<
    IUserInfoForm & {
      factoring_id?: string;
    }
  >();
  const { userType } = useParams<{ userType: string }>();

  if (userType !== "broker" && userType !== "carrier") {
    return <Navigate to="/404" replace />;
  }
  return (
    <OnboardingLayout
      className={styles.applyHaulpayContainer}
      containerClass="max-w-6xl"
      isApplyHaulpay>
      {step !== 4 ? (
        <Stepper
          data={APPLY_HAULPAY_DESCRIPTION_LIST}
          currentStep={step}
          setStep={setStep}
          canNavigate={false}
          className={styles.stepperWrapper}
          containClass="desktop:!bg-background desktop:!px-5"
          isHideMobileTitle
        />
      ) : null}

      <SelectedSection
        step={step}
        setStepCallback={setStep}
        submitData={submitData}
        setSubmitData={setSubmitData}
      />
    </OnboardingLayout>
  );
}
